import React from 'react';
import { getConfiguration } from '../../utils/configuration';
import { getFormattedTimestamp } from '../../utils/getFormattedTimestamp';
import { getCurrencyValue } from '../../utils/getCurrencyValue';
import { convertInAlternativeCurrency } from '../../utils/convertInAlternativeCurrency';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';
import ShopReceiptFooter from './common-includes/ShopReceiptFooter';
import { getLabel } from '../../../data/labels';


function PaymentAndCancelTicketReceipt(props) {
	const conf = getConfiguration();
	
	const additionalStyle = {
			"fontFamily" : "sans-serif",
			"fontSize" : "19px"
	};

	
	const isPayment = props.paymentData? true: false;
	const opData = isPayment? props.paymentData : props.cancelData;
	const operationTitle = isPayment? getLabel('retail.payment_ticket.on_receipt') : getLabel('retail.cancel_ticket.on_receipt');
	const formattedTimestamp =  opData.object.formattedTimestamp || getFormattedTimestamp();
	let effectiveAmount = opData.object.amount > 0? opData.object.amount : opData.object.winc;
	if(!effectiveAmount){
		effectiveAmount = 0;
	}
	const amountWithCurrency = getCurrencyValue(effectiveAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);
	const amountAltCur = convertInAlternativeCurrency(effectiveAmount);
	const terminalBalance = getCurrencyValue(opData.object.terminalBalance, conf.cs.m, conf.cs.nd, conf.cs.ct);
	const promos = opData.object.promotions;

	const dateTimeLabel = opData.dateTimeLabel || getLabel('retail.date_time');
	const amountLabel = opData.amountLabel || getLabel('retail.amount');
	const terminalLabel = opData.terminalLabel || getLabel('retail.terminal_number');
	const operatorLabel = opData.agentLabel || getLabel('retail.operator');
	
	return (
		<body style={additionalStyle}>

			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={operationTitle}></ShopReceiptHeader>
			
			<div>{dateTimeLabel + ": " + formattedTimestamp}</div>
			<div>{amountLabel + ": " + amountWithCurrency} {amountAltCur && <span> / {amountAltCur} </span>}</div>
			{
				opData.showTerminalBalance && <div>{getLabel('retail.terminal_balance') + ": " + terminalBalance}</div>
			}
			<div>{terminalLabel + ": " + opData.object.idTag}</div>
			{
				opData.object.idTicket &&  <div>{getLabel("printer.plain_ticket.header.id") + ": " + opData.object.idTicket}</div>
			}
			{ 
				opData.showOperatorName &&  opData.object?.operator && <div>{operatorLabel + ": " + opData.object.operator}</div>
			}
			<hr className="hr-line" />
			{
					opData.code == 0 && <div className="centerText">{opData.object.idt}</div>
			}
			{
				opData.code != 0 && 
				<div className="error-container">
					<span>{opData.object.idt}</span>
					<br/>
					<span>{opData.object.winc? (getLabel("ticket.paid") + " - Cashback ") : opData.description}</span>
				</div>
			}
			
			{
				promos && 
				<div className="centerText">
				{
					Object.keys(promos).map(function(key){
						const promo = promos[key];
						return <React.Fragment key={'promo-' + key}>
							<div>{promo.desc}</div>
							{
								promo.amn > 0 &&
								<div>{getLabel('retail.amount') + ":" + getCurrencyValue(promo.amn, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
							}
						</React.Fragment>
					})
				}
				</div>
			}
			
			<ShopReceiptFooter></ShopReceiptFooter>
		</body>
    );
}

export default PaymentAndCancelTicketReceipt;